export default "__VITE_IMAGE_ASSET__6e2471e9__";